import { render, staticRenderFns } from "./PagesCard.vue?vue&type=template&id=2494c4aa&scoped=true&"
import script from "./PagesCard.vue?vue&type=script&lang=js&"
export * from "./PagesCard.vue?vue&type=script&lang=js&"
import style0 from "./PagesCard.vue?vue&type=style&index=0&id=2494c4aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2494c4aa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,HepLogo: require('/vercel/path0/components/general/HepLogo.vue').default,ArrowLeft: require('/vercel/path0/components/icons/ArrowLeft.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
